import React from 'react';
import { Link } from 'react-router-dom';
import { ExternalLink, Heart } from 'lucide-react';
import Logo from './Logo';
import { useT } from '../context/LanguageContext';
import { useContent } from '../context/ContentContext';
import { SiteFieldEditor } from './admin/SiteFieldEditor';

const Footer = () => {
  const { t } = useT();
  const { content } = useContent();
  const site = content.site || {};
  const defaultFooterLinks = [
    { label: 'Aktivitetar', href: '/aktiviteter' },
    { label: 'Galleri', href: '/galleri' },
    { label: 'Videoar', href: '/videoar' },
    { label: 'Anmeldingar', href: '/anmeldelser' },
    { label: 'Spørsmål?', href: '/sporsmal' },
  ];
  const footerLinks = Array.isArray(site.footerLinks) ? site.footerLinks : defaultFooterLinks;
  return (
    <footer className="bg-black border-t border-white/5 py-14" data-testid="site-footer">
      <div className="max-w-[1400px] mx-auto px-4 md:px-8">
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-8">
          <div>
            <div data-edit-fields="logoImage" className="cursor-pointer w-fit"><Logo size="md" variant="wide" /></div>
            <p data-edit-fields="footerDescription" className="cursor-pointer text-white/50 text-sm mt-4 max-w-md">{t(site.footerDescription || 'Refuel Weekend – ei helg fylt med tro, fellesskap og musikk. Vi sjåast i Øygarden 2.–4. april.')}</p>
            <div className="mt-3"><SiteFieldEditor title="Rediger footer" fieldKeys={['footerDescription', 'footerLinks', 'creditName', 'creditAgency', 'creditUrl']} testId="edit-site-footer-button" /></div>
          </div>
          <nav className="flex flex-wrap gap-x-6 gap-y-2 text-sm text-white/60" aria-label="Botnmeny">
            {footerLinks.map(({ label, href }) => (
              href?.startsWith('/')
                ? <Link key={`${label}-${href}`} to={href} data-edit-fields="footerLinks" className="hover:text-[#ff2e2e] transition-colors">{t(label)}</Link>
                : <a key={`${label}-${href}`} href={href || '#'} data-edit-fields="footerLinks" className="hover:text-[#ff2e2e] transition-colors">{t(label)}</a>
            ))}
            <Link to="/p-policy" className="hover:text-[#ff2e2e] transition-colors">Personvern</Link>
          </nav>
        </div>

        <div className="mt-10 pt-6 border-t border-white/5 flex flex-col md:flex-row items-center justify-between gap-4 text-sm text-white/40">
          <p>© {new Date().getFullYear()} Refuel Weekend. {t('Alle rettar reserverte.')}</p>
          <div className="flex flex-col sm:flex-row items-center gap-3" data-testid="footer-credits">
            <p className="inline-flex items-center gap-1.5">
              <Heart size={13} className="text-[#ff2e2e]" /> {t('Nettsida er laga av')} <span className="text-white/70 font-semibold">{site.creditName || 'Tristan Husebø Hagen'}</span> {t('og')} <span className="text-white/70 font-semibold">{site.creditAgency || 'Norevio'}</span>
            </p>
            <a href={site.creditUrl || 'https://norevio.site'} target="_blank" rel="noreferrer noopener" data-testid="footer-norevio-link" className="inline-flex items-center gap-1.5 h-8 px-4 rounded-full border border-white/15 text-white/70 text-xs font-bold hover:border-[#ff2e2e] hover:text-[#ff2e2e] transition-colors">
              {t('Les meir om Norevio')} <ExternalLink size={12} />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
